export const AGREEMENTS = ['TERMS_OF_SERVICES', 'PRIVACY_POLICY'];
export const AGREEMENTS_LOAN = ['TERMS_OF_SERVICES', 'PRIVACY_POLICY', 'CONSULTATION'];
export const AGREEMENTS_ACCEPT = ['LOAN_AGREEMENT'];
